import React, { Component } from "react";

// CKeditor
import CKEditor from "react-ckeditor-component";
import { editorReady } from "../../../utils/editor";
import CKEditorInput from "../../../utils/forms/CKEditorInput";

// Components
import Button from "../../utils/Button";

// CSS
import "../../../css/translation-edit-item.css";

class TranslationItem extends Component {
	constructor(props) {
		super(props);
		this.CKEditorInput = new CKEditorInput();
	}

	/*
	 * For whatever reason, CKEditor was flickering when other components were updated.
	 * This makes sure each component will behave.
	 * I'm sure there's a reason why things flickered, but no time to waste on it.
	 */
	shouldComponentUpdate(nextProps) {
		if (
			this.props.item.value !== nextProps.item.value ||
			this.props.item.saving !== nextProps.item.saving ||
			this.props.item.titleChanged !== nextProps.item.titleChanged
		) {
			return true;
		}

		return false;
	}

	render() {
		const { item } = this.props;

		return (
			<div className={`translation-edit-item` + (item.successfull ? " saved" : "")}>
				<h3>{item.title}</h3>

				<div>
					{item.isTextarea ? (
						<CKEditor
							scriptUrl="/ckeditor/ckeditor.js"
							content={item.value}
							config={{
								toolbar: "Minimum",
								filebrowserImageBrowseUrl: "/image-browser",
								filebrowserBrowseUrl: "/file-browser",
								uploadUrl: process.env.REACT_APP_API_URL + `files`
							}}
							events={{
								instanceReady: editorReady.bind(this),
								change: e => this.props.editorChange(e, "value")
							}}
							ref={instance => {
								this.CKEditorInput.addEditor("value", instance);
							}}
						/>
					) : (
						<input
							type="text"
							id="value"
							value={item.value}
							onChange={this.props.handleInputChange}
						/>
					)}
				</div>

				<Button
					clickHandler={this.props.saveHandler}
					text="Save"
					isDisabled={!item.titleChanged}
					isLoading={item.saving}
				/>
			</div>
		);
	}
}

export default TranslationItem;



// WEBPACK FOOTER //
// ./src/components/admin/translations/TranslationItem.js